export default {
    /** 封装try catch stringify */
    safelyStringify: function (obj, replacer, space) {
        try {
            return JSON.stringify(obj, replacer, space);
        }
        catch (e) {
            return '{}';
        }
    },
};
